import React from 'react';
import { Person } from '@mui/icons-material';

interface LoadingStateProps {
    message?: string;
}

interface ErrorStateProps {
    error: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ message = "Chargement des participants..." }) => {
    return (
        <div className="users-container">
            <div className="section-header">
                <div className="header-left">
                    <div className="section-icon">
                        <Person />
                    </div>
                    <h2 className="section-title">{message}</h2>
                </div>
            </div>
        </div>
    );
};

export const ErrorState: React.FC<ErrorStateProps> = ({ error }) => {
    return (
        <div className="users-container">
            <div className="section-header">
                <div className="header-left">
                    <div className="section-icon">
                        <Person />
                    </div>
                    <h2 className="section-title">Erreur: {error}</h2>
                </div>
            </div>
        </div>
    );
};
